// extracted by mini-css-extract-plugin
module.exports = {"picture":"picture_picture__3qgwf","logo":"picture_logo__1HwuL","user":"picture_user__2oyuR"};